import { IContact } from '@core/interfaces/contact/contact.interface';

export const CONTACT: IContact = {
  firstName: 'István',
  lastName: 'Kovács',
  phone: '+36304201970',
  email: 'kovacs.instvan@interticket.hu',
  jobDescription: 'Programinformációk, vásárlási támogatás',
  address: '1111 Budapest, Domb utca 21',
  isPublic: true,
};

export const CONTACTS: IContact[] = [
  CONTACT,
  {
    firstName: 'Béla',
    lastName: 'Szabó',
    phone: '+36303433999',
    email: 'bela.szabo@interticket.hu',
    jobDescription: 'Technikai támogatás',
    address: '1118 Budapest, Hegy utca 44',
    isPublic: true,
  },
];
